import { koComponent } from "../../../ko-utils";
import $api from "../../../api";
// import { displayTypes } from './utils';

class AssignProjects {
  constructor(params, parentPage) {
    this.parentPage = parentPage;

    this.user = params.user;
    this.currentUser = ko.observable(params.currentUser);
    this.newInvitation = params.newInvitation;

    this.projects = ko.observableArray(params.projects);
    this.isPermissionsSupportEnabled = ko.observable(
      params.isPermissionsSupportEnabled
    );
    this.isInTrial = window.auth.user.CurrentCompany.IsInTrial;

    this.hasWorkDomain = this.getServerSideData("hasWorkDomain");

    if (this.user) {
      this.hasAccessToAllProjects = ko.observable(
        params.user.currentCompany().hasAccessToAllProjects()
      );
      this.selectedProjects = ko.observableArray(
        params.user.projectSharings().map((i) => i.projectId())
      );
    } else {
      this.hasAccessToAllProjects = ko.observable(
        params.newInvitation().currentCompany().hasAccessToAllProjects()
      );
      this.selectedProjects = ko.observableArray(
        params
          .newInvitation()
          .projectSharings()
          .map((i) => i.projectId())
      );
    }
  }

  /**
   * @param {any} key
   */
  getServerSideData(key) {
    if (window.serverSide) {
      return window.serverSide[key];
    }
  }

  save() {
    if (this.user) {
      $api.company.userProjects(
        {
          id: this.user.id(),
        },
        {
          hasAccessToAllProjects: this.hasAccessToAllProjects(),
          projectIds: this.selectedProjects(),
        },
        (r) => {
          window.location = `/settings/users`;
        }
      );
    } else {
      this.newInvitation()
        .currentCompany()
        .hasAccessToAllProjects(this.hasAccessToAllProjects());
      this.newInvitation().projectSharings(
        this.selectedProjects().map((i) => {
          const p = this.projects().filter((y) => y.id === i)[0];
          return {
            projectId: ko.observable(p.id),
            name: ko.observable(p.name),
          };
        })
      );

      this.parentPage.parentPage.closeDialog();
      // $('#assign-projects-modal').modal().hide()
    }
  }
}

export default koComponent("assign-projects-view", AssignProjects);
